import { TranslateService } from '@ngx-translate/core';
import { AllInputTypes, FormInputConfig, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { ICreateSpecializedRolesRequest } from '../dtos';
import { getIdFormConfig } from '../../../../../views/pages/adminstration/temp-common/utils';
import { Validators } from '@angular/forms';

export class CreateRoleModel implements ICreateSpecializedRolesRequest {
  name: string;
  systemRoleId?: string;

  private constructor(request: ICreateSpecializedRolesRequest) {
    this.name = request.name;
    this.systemRoleId = request.systemRoleId;
  }

  static create(request: ICreateSpecializedRolesRequest): CreateRoleModel {
    return new CreateRoleModel(request);
  }

  static createDefault(): CreateRoleModel {
    return CreateRoleModel.create({
      name: '',
      systemRoleId: ''
    });
  }

  getFormConfig(roles: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
      return [
        // getIdFormConfig(this.id),
        {
          type: AllInputTypes.Text,
          name: 'name',
          label: translate?.instant('GENERAL.NAME'),
          placeholder: `${translate?.instant('GENERAL.ENTER')} ${translate?.instant('GENERAL.NAME')}`,
          defaultValue: this.name,
          isDisable: !isVisible,
          widthClass: 'col-12',
          validation: [{ function: Validators.required, errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('GENERAL.NAME')}` }]
        },
        {
          type: AllInputTypes.Select,
          name: 'systemRoleId',
          label: translate?.instant('USER_MANAGEMENT.SYSTEM_ROLES'),
          placeholder: translate?.instant('GENERAL.SELECT'),
          widthClass: 'col-md-12',
          listValues: roles,
          defaultValue: this.systemRoleId,
          isDisable: !isVisible
        }
      ];
    }
}
